











import { Vue, Prop, Component } from 'vue-property-decorator';
import RandomColor from '@/shared/utils/random-color';
import NameSplit from '@/shared/utils/name-split';
import UserAvatar from './user-avatar.class';

@Component
export default class UserAvatarComponent extends Vue {
  @Prop({ required: true }) user?: UserAvatar;

  @Prop() size?: number;

  private color = RandomColor.get();

  get name(): string {
    if (this.user && this.user.name) {
      return NameSplit.formatName(this.user.name);
    }
    return '';
  }
}
